/* eslint-disable max-classes-per-file */
import dayjs from "@/utils/dayjs";

export interface RequestPhoneLoginInterface {
  type: string;
  prefix_phone: string;
  phone_number: string;
}

export class DataSendSMSVerificationInterface {
  round: string;

  expire: string;

  expireSeconds: number;

  isBlock: boolean;

  blockData: {
    resendInTime: string;
    resendInSeconds: number;
    resendInMinutes: number;
  };

  prefixPhone: string;

  phoneNumber: string;

  ref: string;

  constructor(data: any) {
    this.round = data?.round || "";
    this.expire = data?.expire || "";
    this.expireSeconds = dayjs(data?.expire).diff(dayjs(), "second") || 0;
    this.isBlock = data?.isBlock || false;
    this.blockData = {
      resendInTime: data?.blockData?.resendInTime || "",
      resendInSeconds: data?.blockData?.resendInSeconds || 0,
      resendInMinutes: data?.blockData?.resendInMinutes || 0,
    };
    this.prefixPhone = data?.prefixPhone || "";
    this.phoneNumber = data?.phoneNumber || "";
    this.ref = data?.ref || "";
  }
}

export class ResponseSendSMSVerificationPresenter {
  status: boolean;

  message: string;

  data: DataSendSMSVerificationInterface;

  constructor(data: any) {
    this.status = data?.status || false;
    this.message = data?.message || "";
    this.data = new DataSendSMSVerificationInterface(data?.data);
  }
}
